import React from 'react';
import Styled from 'styled-components/macro';
import {PopoverHandler} from '@forecast-it/design-system';
import moreHorizontalIcon from '../../../../images/components/overlay/navigation-show-more-horizontal-black.svg';

// sky/comp/button/color/border/midemphasismonochrome/default
const COLOR_BUTTON_BORDER = '#6b6d7b';
// sky/sys/color/border/enabled
const COLOR_BORDER_ENABLED = '#6b6d7b';
// sky/sys/color/text/content/main
const COLOR_TEXT_MAIN = '#232334';

const MoreButton = Styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 44px;
	padding: 0 12px;
	border: 1px solid ${COLOR_BUTTON_BORDER};
	border-radius: 8px;
	background: transparent;
	cursor: pointer;
	&:hover {
		background-color: rgba(0, 0, 0, 0.04);
	}
`;

const DropdownMenuShell = Styled.ul`
	list-style: none;
	margin: 0;
	padding: 8px 0;
	background: #ffffff;
	border: 1px solid ${COLOR_BORDER_ENABLED};
	border-radius: 8px;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	min-width: 160px;
`;

const DropdownMenuItemStyled = Styled.li`
	display: flex;
	align-items: center;
	min-height: 44px;
	padding: 0 16px;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.15px;
	color: ${COLOR_TEXT_MAIN};
	cursor: pointer;
	&:hover {
		background-color: rgba(0, 0, 0, 0.04);
	}
`;

type DropdownMenuItemProps = {
	children: React.ReactNode;
	onClick: () => void;
};

const DropdownMenuItem: React.FC<DropdownMenuItemProps> = ({children, onClick}) => {
	const {setOpen} = PopoverHandler.usePopoverState();
	return (
		<DropdownMenuItemStyled
			onClick={() => {
				onClick();
				setOpen(false);
			}}
		>
			{children}
		</DropdownMenuItemStyled>
	);
};

type DropdownMenuProps = {
	children: React.ReactNode;
	trigger?: React.ReactElement;
};

const DropdownMenu: React.FC<DropdownMenuProps> & {Item: typeof DropdownMenuItem} = ({children, trigger}) => {
	return (
		<PopoverHandler>
			<PopoverHandler.Trigger>
				{trigger ?? (
					<MoreButton aria-label="More actions">
						<img src={moreHorizontalIcon} alt="" width={20} height={20} />
					</MoreButton>
				)}
			</PopoverHandler.Trigger>
			<PopoverHandler.Content align="end" offset={4} showArrow={false}>
				<DropdownMenuShell>{children}</DropdownMenuShell>
			</PopoverHandler.Content>
		</PopoverHandler>
	);
};

DropdownMenu.Item = DropdownMenuItem;

export default DropdownMenu;
